import type { SystemOverview } from "@trading-os/shared-types";

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      ...init?.headers
    }
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    Object.assign(error, { status: response.status });
    throw error;
  }
  return response.json() as Promise<T>;
}

export const api = {
  session: () => request<{ authenticated: true; mode: "PAPER"; account: "Sim101" }>("/api/auth/session"),
  login: (password: string) => request<{ authenticated: true }>("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ password })
  }),
  logout: () => request<{ authenticated: false }>("/api/auth/logout", { method: "POST" }),
  overview: () => request<SystemOverview>("/api/overview"),
  trades: () => request<{ trades: Array<Record<string, unknown>> }>("/api/trades"),
  rejected: () => request<{ rejectedSignals: Array<Record<string, unknown>> }>("/api/rejected-signals"),
  strategies: () => request<{ strategyVersions: Array<Record<string, unknown>> }>("/api/strategy-versions"),
  health: () => request<{
    api: string;
    database: string;
    services: Array<Record<string, unknown>>;
    incidents: Array<Record<string, unknown>>;
    paperModeGuard: boolean;
  }>("/api/system-health")
};
